import styled from 'styled-components';

type SelectionCheckBadgeProps = {
  className?: string;
};

const Badge = styled.svg.attrs({
  'aria-hidden': true,
  fill: 'none',
  focusable: 'false',
  viewBox: '0 0 27.0847 27.0845',
  xmlns: 'http://www.w3.org/2000/svg',
})`
  width: ${({ theme }) => theme.scale.px(27)};
  height: ${({ theme }) => theme.scale.px(27)};
  display: block;
  flex: 0 0 auto;

  & rect {
    fill: ${({ theme }) => theme.colors.support.success};
  }

  & path {
    fill: ${({ theme }) => theme.colors.surface.subtle};
  }
`;

export function SelectionCheckBadge({ className }: SelectionCheckBadgeProps) {
  return (
    <Badge className={className}>
      <rect width="27.0845" height="27.0845" rx="13.5423" />
      <path d="M11.2897 20.77C10.844 20.77 10.4134 20.5971 10.0903 20.2849L6.24403 16.567C5.55828 15.904 5.53912 14.8105 6.20173 14.1243C6.86434 13.4381 7.95712 13.4189 8.64287 14.0819L11.0909 16.448L18.2632 6.99741C18.8397 6.23741 19.9228 6.08946 20.6822 6.66643C21.4417 7.24339 21.5896 8.32714 21.013 9.08714L12.6648 20.0871C12.3662 20.4803 11.914 20.727 11.422 20.7649C11.3779 20.7682 11.3338 20.77 11.2897 20.77Z" />
    </Badge>
  );
}
